
import React from "react";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import "./Footer.css";

function Footer() {
  const year = new Date().getFullYear();

  const PHONE_E164 = "+17622154738";
  const PHONE_DISPLAY = "(762) 215-4738";

  const STREET = "3355 Deans Bridge Rd Ste D";
  const CITY = "Augusta";
  const STATE = "GA";
  const ZIP = "30906";

  const FACEBOOK_URL =
    "https://www.facebook.com/Big-Pace-Barber-Shop-and-Beauty-Salon-2-103462851469536/?ref=page_internal";

  const INSTAGRAM_URL =
    "https://instagram.com/bigpacebarbershop?igshid=6lx9wphfn0pl";

  const AVON_URL =
    "https://www.avon.com/repstore/pam?rep=pam";

  const mapsQuery = encodeURIComponent(
    `${STREET}, ${CITY}, ${STATE} ${ZIP}`
  );

  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${mapsQuery}`;

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="footer-brand-heading">
            <span className="footer-brand-mark" aria-hidden="true">
              💈
            </span>

            <div>
              <p className="footer-business-name">
                Big Pace Barber Shop
              </p>
              <p className="footer-business-subtitle">
                & Beauty Salon 2
              </p>
            </div>
          </div>

          <p className="footer-description">
            Barber and beauty services in Augusta, Georgia.
            Walk-ins are always welcome.
          </p>
        </div>

        <div className="footer-contact">
          <h2 className="footer-heading">Visit Us</h2>

          <address className="footer-address">
            {STREET}
            <br />
            {CITY}, {STATE} {ZIP}
          </address>

          <a className="footer-link" href={`tel:${PHONE_E164}`}>
            {PHONE_DISPLAY}
          </a>

          <a
            className="footer-link"
            href={mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Get Directions
          </a>
        </div>

        <div className="footer-connect">
          <h2 className="footer-heading">Follow Big Pace</h2>

          <div className="footer-social-links">
            <a
              href={FACEBOOK_URL}
              aria-label="Visit Big Pace on Facebook"
              title="Facebook"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-link"
            >
              <FaFacebookF aria-hidden="true" />
              <span>Facebook</span>
            </a>

            <a
              href={INSTAGRAM_URL}
              aria-label="Visit Big Pace on Instagram"
              title="Instagram"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-link"
            >
              <FaInstagram aria-hidden="true" />
              <span>Instagram</span>
            </a>
          </div>

          <div className="footer-avon">
            <p className="footer-avon-heading">
              Looking for fragrances, skincare, or gifts?
            </p>

            <a
              href={AVON_URL}
              target="_blank"
              rel="noopener noreferrer sponsored"
              className="footer-link footer-avon-link"
              aria-label="Shop Pamela's Avon online store"
            >
              Shop Avon Online ↗
            </a>

            <p className="footer-avon-note">
              Independent Avon Representative · Pamela
            </p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p>
            © {year} Big Pace Barber Shop and Beauty Salon 2
          </p>

          <p>
            Website created by{" "}
            <a
              href="https://pamelajterrell.com"
              target="_blank"
              rel="noopener noreferrer"
              className="creator-link"
            >
              Pamela J. Terrell
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
